module.exports = __webpack_public_path__ + "img/glow_in_the_dark_flashlight.1a2e163e.jpg";